import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-success',
    imports: [],
    templateUrl: './success.component.html',
    styleUrl: './success.component.scss'
})
export class SuccessComponent {
    assetUrl = environment.assetBaseUrl
}
